import { render, staticRenderFns } from "./IncidenteSeguridadIcon.vue?vue&type=template&id=ab4d08ac&scoped=true"
import script from "./IncidenteSeguridadIcon.vue?vue&type=script&lang=js"
export * from "./IncidenteSeguridadIcon.vue?vue&type=script&lang=js"
import style0 from "./IncidenteSeguridadIcon.vue?vue&type=style&index=0&id=ab4d08ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4d08ac",
  null
  
)

export default component.exports